/**
 * AI model options for widget configuration.
 * Default must match backend config MODEL_NAME (e.g. CLAUDE_4_5_SONNET).
 */
export const DEFAULT_AI_MODEL = 'CLAUDE_4_5_SONNET';

export const AI_MODEL_OPTIONS = [
  { value: 'CLAUDE_4_5_SONNET', label: 'Claude 4.5 Sonnet' },
  { value: 'GPT_4_O', label: 'GPT 4.0' },
  { value: 'GEMINI_25_FLASH', label: 'Gemini 2.5 Flash' },
  { value: 'GPT_5_2', label: 'GPT 5.2' },
];
